import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Typography,
  Divider,
  Box,
  Tooltip,
  IconButton,
  Paper,
  Card,
  CardContent,
  TextareaAutosize,
  Switch,
  FormControl,
  FormGroup,
  FormControlLabel,
  Select,
  Checkbox,
  MenuItem,
} from "@mui/material";
import { ReactComponent as Plant } from "../../assets/images/Plant.svg";
import { ReactComponent as Setting } from "../../assets/images/Setting.svg";
import { ReactComponent as Date } from "../../assets/images/Date.svg";
import { ReactComponent as User } from "../../assets/images/User.svg";
import { ReactComponent as PartExtension } from "../../assets/images/PartExtension.svg";
import { ReactComponent as CloseIcon } from "../../assets/images/CloseIcon.svg";
import CircularProgress from "@mui/material/CircularProgress";
import "../../styles/ownerPartRequest.css";
import { ReactComponent as Info } from "../../assets/images/Info.svg";
import { ReactComponent as MatrixCriteria } from "../../assets/images/MatrixCriteria.svg";
import { automationHttpRequest } from "../../api/httpRequests";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { ReactComponent as ModificationIconSetting } from "../../assets/images/ModificationIconSetting.svg";
import { ReactComponent as DropdownIcon } from "../../assets/images/DropdownIcon.svg";

const OwnerModificationDialog = ({
  partRequestNumber,
  open,
  dialogData,
  closeDialog,
  modificationType,
  dialogLoading,
  fetchPartRequestHistory,
  onRequestStatusUpdate,
}) => {
  const [ownerComment, setOwnerComment] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [loadingReject, setLoadingReject] = React.useState(false);
  const [ownerModalLoading, setOwnerModalLoading] = React.useState(false);
  const inputStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    color: "#212F37",
    margin: "0px 20px",
  };
  const [modify, setModify] = useState(false);
  const [descriptionValue, setDescriptionValue] = useState({
    maximumStock: "",
    maximumStockLevel: "",
  });
  const [futureValues, setFutureValues] = useState({
    maximumStock: "",
    maximumStockLevel: "",
  });
  const [modifyLoader, setModifyLoader] = useState(false);
  const [minStockCurrentValue, setMinStockCurrentValue] = useState("");
  const [maxStockCurrentValue, setMaxStockCurrentValue] = useState("");
  const [minFutCurrentValue, setMinFutCurrentValue] = useState("");
  const [minFutCurrValueChanged, setMinFutCurrValueChanged] = useState(false);
  const [maxFutCurrValueChanged, setMaxFutCurrValueChanged] = useState(false);
  const [abcFutCurrValueChanged, setAbcFutCurrValueChanged] = useState(false);
  const [maxFutCurrentValue, setMaxFutCurrentValue] = useState("");
  const [minJustValue, setMinJustValue] = useState("");
  const [maxJustValue, setMaxJustValue] = useState("");
  const [requestID, setRequestID] = useState(false);
  const [currAbcIndicator, setCurrAbcIndicator] = useState("");
  const [futAbcIndicator, setFutAbcIndicator] = useState(
    "A : Significant Material",
  );
  const [justiAbcIndicator, setJustiAbcIndicator] = useState("");
  const [critcialIndicator, setCritcialIndicator] = useState("");
  const [storageLocation, setStorageLocation] = useState("");
  const [storageBin, setStorageBin] = useState("");
  const [partModificationDialog, setPartModificationDialog] = useState(false);
  const [dfFlag, setDfFlag] = useState("");
  const [dfStorage, setDfStorage] = useState("");
  const [plantName, setPlantName] = useState();
  const [noDataAvailable, setNoDataAvailable] = useState(false);
  const [modifyButton, setModifyButton] = useState(false);
  const [futurecritcialIndicator, setFutureCritcialIndicator] = useState("");
  const [futurestorageLocation, setFutureStorageLocation] = useState("");
  const [futurestorageBin, setFutureStorageBin] = useState("");

  // React.useEffect(()=>{
  //   setOwnerComment("")
  //  },[partRequestNumber])

  const headingStyle = {
    fontWeight: "700",
  };
  const ABCoptions = [
    "A : Significant Material",
    "B : Medium Significance",
    "C : Low significance",
  ];
  const headingStyleReason = {
    fontWeight: "700",
    // width: "300px",
    margin: "8px",
  };

  React.useEffect(() => {
    if (dialogData) {
      setMaxStockCurrentValue(dialogData?.maximum_stock_level);
      setMinStockCurrentValue(dialogData?.minimum_stock_level);
      setMaxJustValue(dialogData?.justification_for_change_in_maximum_stock);
      setMinJustValue(dialogData?.justification_for_change_in_minimum_stock);
      setMaxFutCurrentValue(dialogData?.future_maximum_stock_level);
      setMaxFutCurrValueChanged(true);
      setMinFutCurrentValue(dialogData?.future_minimum_stock_level);
      setMinFutCurrValueChanged(true);
      setCurrAbcIndicator(dialogData?.ABC_indicator);
      setFutAbcIndicator(dialogData?.future_abc_indicator);
      setFutureCritcialIndicator(dialogData?.critical_part);
      setFutureStorageLocation(dialogData?.storage_location);
      setFutureStorageBin(dialogData?.storage_bin);
      setDfStorage(dialogData?.df_storage_location || "");
      setDfFlag(dialogData?.df_plant || "");
      setOwnerComment(dialogData?.modification_comment || "");
    }
  }, [dialogData]);
  const handleIndicatorSelectChange = (event) => {
    // setChecked(!checked)
    let val = event.target.checked ? "X" : "";
    setFutureCritcialIndicator(val);
  };
  const handleClose = () => {
    setOwnerComment("");
    closeDialog();
  };

  const handleSelectABCChange = (event) => {
    setFutAbcIndicator(event?.target?.value);
  };

  const handleInputChange = (e, key) => {
    const value = e.target.value;
    // Perform any validation or processing if needed
    // Update the corresponding state based on the key
    if (key === "minFutCurrentValue") {
      const numericValue = parseInt(value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMinFutCurrentValue(numericValue);
        setMinFutCurrValueChanged(true);
      }
      if (value === "") {
        setMinFutCurrentValue("");
        setMinFutCurrValueChanged(false);
      }
    } else if (key === "maxFutCurrentValue") {
      // if (parseInt(value, 10) < parseInt(minFutCurrentValue, 10)) {
      //   toast.error("Maximum Stock should be greater than Minimum Stock.", {
      //     position: toast.POSITION.TOP_CENTER,
      //     autoClose: 800,
      //   });
      // }
      if (
        parseInt(value, 10) < parseInt(minFutCurrentValue, 10) ||
        (parseInt(value, 10) === 0 && parseInt(minFutCurrentValue, 10) === 0)
      ) {
        toast.error("Maximum Stock should be greater than Minimum Stock.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
      const numericValue = parseInt(value, 10);
      if ((!isNaN(numericValue) && numericValue != "") || numericValue === 0) {
        setMaxFutCurrentValue(numericValue);
        setMaxFutCurrValueChanged(true);
      }
      if (value === "") {
        setMaxFutCurrentValue("");
        setMaxFutCurrValueChanged(false);
      }
    } else if (key === "minJustValue") {
      setMinJustValue(value);
    } else if (key === "maxJustValue") {
      setMaxJustValue(value);
    } else if (key === "minStockCurrentValue") {
      const numericValue = parseInt(value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setMinStockCurrentValue(numericValue);
      }
      if (value === "") {
        setMinStockCurrentValue("");
      }
    } else if (key === "maxStockCurrentValue") {
      const numericValue = parseInt(value, 10);
      if (!isNaN(numericValue) && numericValue != "") {
        setMaxStockCurrentValue(numericValue);
      }
      if (value === "") {
        setMaxStockCurrentValue("");
      }
    }
    setModifyButton(true);
  };

  const handlePlantInputChange = (e, key) => {
    const value = e.target.value;
    // Perform any validation or processing if needed
    // Update the corresponding state based on the key
    if (key === "currAbcIndicator") {
      setCurrAbcIndicator(value);
    } else if (key === "futAbcIndicator") {
      setFutAbcIndicator(value);
      setAbcFutCurrValueChanged(true);
    } else if (key === "justiAbcIndicator") {
      setJustiAbcIndicator(value);
    } else if (key === "futurecritcialIndicator") {
      setFutureCritcialIndicator(value);
    } else if (key === "futurestorageLocation") {
      setFutureStorageLocation(value);
    } else if (key === "futurestorageBin") {
      if (value.length <= 10) {
        setFutureStorageBin(value);
      } else {
        toast.error("Limit Exceeded.", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 800,
        });
      }
    } else if (key === "currAbcIndicator") {
      setCurrAbcIndicator(value);
    }
    setModifyButton(true);
  };
  const handleApproveRequest = async () => {
    const values = {
      request_id: partRequestNumber,
      minimum_stock_level: dialogData?.minimum_stock_level,
      maximum_stock_level: dialogData?.maximum_stock_level,
      future_maximum_stock_level:
        parseInt(maxFutCurrentValue) ||
        dialogData?.future_maximum_stock_level ||
        0,
      future_minimum_stock_level:
        parseInt(minFutCurrentValue) ||
        dialogData?.future_minimum_stock_level ||
        0,
      justification_for_change_in_maximum_stock:
        maxJustValue || dialogData?.justification_for_change_in_maximum_stock,
      justification_for_change_in_minimum_stock:
        minJustValue || dialogData?.justification_for_change_in_minimum_stock,
      df_plant: dfFlag || "",
      df_storage_location: dfStorage || "",
      ABC_indicator: dialogData?.ABC_indicator,
      critical_part: futurecritcialIndicator || dialogData?.critical_part,
      storage_location: futurestorageLocation || dialogData?.storage_location,
      storage_bin: futurestorageBin || dialogData?.storage_bin,
      future_abc_indicator: futAbcIndicator || dialogData?.future_abc_indicator,
      justification_for_change_in_abc_indicator:
        dialogData?.justification_for_change_in_abc_indicator,
      modification_comment: ownerComment,
    };
    try {
      setLoading(true);
      const response = await automationHttpRequest.post(
        "/modification_update/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        onRequestStatusUpdate?.(partRequestNumber, "Approved");
        setLoading(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setOwnerComment("");
        closeDialog();
      }
    } catch (error) {
      setLoading(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 500,
      });
    }
  };

  const handleRejectRequest = async () => {
    const values = {
      request_id: partRequestNumber,
      minimum_stock_level: dialogData?.minimum_stock_level,
      maximum_stock_level: dialogData?.maximum_stock_level,
      future_maximum_stock_level:
        parseInt(maxFutCurrentValue) ||
        dialogData?.future_maximum_stock_level ||
        0,
      future_minimum_stock_level:
        parseInt(minFutCurrentValue) ||
        dialogData?.future_minimum_stock_level ||
        0,
      justification_for_change_in_maximum_stock:
        maxJustValue || dialogData?.justification_for_change_in_maximum_stock,
      justification_for_change_in_minimum_stock:
        minJustValue || dialogData?.justification_for_change_in_minimum_stock,
      df_plant: dfFlag || "",
      df_storage_location: dfStorage || "",
      ABC_indicator: dialogData?.ABC_indicator,
      critical_part: futurecritcialIndicator || dialogData?.critical_part,
      storage_location: futurestorageLocation || dialogData?.storage_location,
      storage_bin: futurestorageBin || dialogData?.storage_bin,
      future_abc_indicator: futAbcIndicator || dialogData?.future_abc_indicator,
      justification_for_change_in_abc_indicator:
        dialogData?.justification_for_change_in_abc_indicator,
      modification_comment: ownerComment,
    };

    try {
      setLoadingReject(true);
      const response = await automationHttpRequest.post(
        "/modification_reject/",
        { ...values },
        {
          headers: {
            session_id: localStorage.getItem("session_id"),
            userEmail: localStorage.getItem("MRO_user_email"),
          },
          params: {},
        },
      );
      if (response?.data?.status) {
        onRequestStatusUpdate?.(partRequestNumber, "Rejected");
        setLoadingReject(false);
        toast.success(response?.data?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setOwnerComment("");
        closeDialog();
      }
    } catch (error) {
      setLoadingReject(false);
      toast.error("Unable to process the request. Please try again!", {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 500,
      });
    }
  };

  const isEnabled = ownerComment?.trim()?.length > 0;
  const ValueDisplay = ({
    future,
    justification,
    justifyValue,
    futureValue,
    current,
    currentValue,
    dfPlant,
    dfStorage,
  }) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
          }}
        >
          {current && (
            <Typography
              className="smallNarrowValueMod"
              style={{ ...headingStyle, margin: "8px 10px 10px 65px" }}
            >
              {currentValue}
            </Typography>
          )}
          {future && (
            <Typography
              className="smallNarrowValueMod"
              style={{ ...headingStyle, margin: "8px 10px 10px 65px" }}
            >
              {futureValue?.length > 3 ? (
                <Tooltip title={futureValue} arrow>
                  <span>{futureValue?.slice(0, 3) + "..."}</span>
                </Tooltip>
              ) : (
                futureValue
              )}
            </Typography>
          )}
          {justification && (
            <Typography
              className="narrowValueReason"
              style={{ ...headingStyleReason }}
            >
              {justifyValue.length > 30 ? (
                <Tooltip title={justifyValue} arrow>
                  <span>{justifyValue.slice(0, 30) + "..."}</span>
                </Tooltip>
              ) : (
                justifyValue
              )}
            </Typography>
          )}
        </div>
      </>
    );
  };

  const showInformation = () => {
    return (
      <>
        <div
          style={{
            height: "540px",
            width: "500px",
            position: "relative",
            top: "-20px",
            left: "-56px",
          }}
        >
          <MatrixCriteria />
        </div>
      </>
    );
  };

  const MaterialCardData = () => {
    const cardData = { ...dialogData?.attribute_data };
    const cardDataValue = Object.entries(cardData);
    const middleIndex = Math.ceil(cardDataValue.length / 2);
    const materialNumberDetailsFirstRow = cardDataValue.slice(0, middleIndex);
    const materialNumberDetailsSecondRow = cardDataValue.slice(middleIndex);

    return (
      <>
        <div
          style={{
            display: "flex",
            margin: "10px",
            borderRadius: "4px",
          }}
        >
          <div className="row">
            {materialNumberDetailsFirstRow.map(([element, value], index) => (
              <>
                <div className="rowelement">
                  <div key={index} className="elementHeading">
                    {element} :-
                  </div>
                  <div key={index} className="element">
                    {value ? value : "--"}
                  </div>
                </div>
              </>
            ))}
          </div>
          <div className="row">
            {materialNumberDetailsSecondRow.map(([element, value], index) => (
              <>
                <div className="rowelement">
                  <div key={index} className="elementHeading">
                    {element} :-
                  </div>
                  <div key={index} className="element">
                    {value ? value : "--"}
                  </div>
                </div>
              </>
            ))}
          </div>
        </div>
      </>
    );
  };

  const handleToggleChangePlant = (event) => {
    setDfFlag(event.target.checked ? "X" : "");
  };

  const handleToggleChangeStorage = (event) => {
    setDfStorage(event.target.checked ? "X" : "");
  };
  return (
    <>
      <Dialog
        open={open}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        PaperProps={{
          sx: {
            maxWidth: "1400px",
            borderRadius: "10px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div className="dialogHeading">
            {/* <ModificationIconSetting
              style={{ height: "60px" }}
              onClick={handleClose}
            /> */}
            <Typography
              sx={{
                fontFamily: "Verdana",
                fontSize: "24px",
                fontWeight: "600",
              }}
            >
              Request For Part Modification
            </Typography>
            <Typography
              sx={{
                fontFamily: "Verdana",
                fontSize: "18px",
                fontWeight: "600",
                // background: "#EFEFEF",
                padding: "6px",
                borderRadius: "4px",
              }}
            >
              Requested ID-{" "}
              <span
                style={{
                  fontSize: "18px",
                  fontWeight: "600",
                  marginLeft: "10px",
                }}
              >
                #{partRequestNumber}
              </span>
            </Typography>
          </div>
          <CloseIcon style={{ cursor: "pointer" }} onClick={handleClose} />
        </DialogTitle>
        <DialogContent sx={{ width: "1260px", margin: "10px" }}>
          {dialogLoading ? (
            <>
              <Box sx={{ display: "flex" }}>
                <CircularProgress style={{ color: "#C6003D" }} />
              </Box>
            </>
          ) : (
            <DialogContentText>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-around",
                  margin: "20px",
                }}
              >
                <div className="headers">
                  <div style={inputStyle}>
                    <Typography>Material Number</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.material_number}
                    </Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <Plant /> */}
                  <div style={inputStyle}>
                    <Typography>Modification Required For Plant</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.plant_name || "-"}
                    </Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <User /> */}
                  <div style={inputStyle}>
                    <Typography>Submitted By</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.submitted_by || "-"}
                    </Typography>
                  </div>
                </div>
                <div className="headers">
                  {/* <Date /> */}
                  <div style={inputStyle}>
                    <Typography>Date of Submission</Typography>
                    <Typography style={headingStyle}>
                      {dialogData?.date_of_submission || "-"}
                    </Typography>
                  </div>
                </div>
              </div>
              {modificationType === "plant_specific" && (
                <>
                  <Card>
                    <CardContent sx={{ margin: "20px" }}>
                      <div className="modificationStyle">
                        <Typography
                          sx={{
                            fontFamily: "Verdana",
                            fontSize: "18px",
                            fontWeight: 700,
                            color: "#C6003D",
                          }}
                        >
                          Replenishment Level
                        </Typography>
                      </div>
                      {/* <Divider
                      style={{ margin: "20px 0px", background: "#EFEFEF" }}
                    /> */}
                      {/* <div className="creationHeadingMod">
                        <Typography style={{ color: "black", fontWeight: 600, marginLeft:"50px" }}>
                          Current Value
                        </Typography>
                        <Typography style={{ color: "black", fontWeight: 600,marginLeft:"50px" }}>
                          Proposed Value
                        </Typography>
                        <Typography style={{ color: "black", fontWeight: 600, marginLeft:"50px" }}>
                          Reason for Change
                        </Typography>
                      </div> */}
                      {/* <div className="valueDisplay">
                        <Typography className="subHeading">
                          Minimum Stock
                        </Typography>
                        <ValueDisplay
                          current={true}
                          future={true}
                          justification={true}
                          justifyValue={
                            dialogData?.justification_for_change_in_minimum_stock
                              ? dialogData?.justification_for_change_in_minimum_stock
                              : "-"
                          }
                          currentValue={
                            dialogData?.minimum_stock_level
                              ? dialogData?.minimum_stock_level
                              : "-"
                          }
                          futureValue={
                            dialogData?.future_minimum_stock_level
                              ? dialogData?.future_minimum_stock_level
                              : "-"
                          }
                        />
                      </div> */}
                      {/* <Divider
                      style={{ background: "#EFEFEF", margin: "4px 0px" }}
                    /> */}
                      {/* <div className="valueDisplay">
                        <Typography className="subHeading">
                          Maximum Stock
                        </Typography>
                        <ValueDisplay
                          future={true}
                          current={true}
                          justification={true}
                          justifyValue={
                            dialogData?.justification_for_change_in_maximum_stock
                              ? dialogData?.justification_for_change_in_maximum_stock
                              : "-"
                          }
                          currentValue={
                            dialogData?.maximum_stock_level
                              ? dialogData?.maximum_stock_level
                              : "-"
                          }
                          futureValue={
                            dialogData?.future_maximum_stock_level
                              ? dialogData?.future_maximum_stock_level
                              : "-"
                          }
                        />
                      </div> */}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          justifyItems: "center",
                        }}
                      >
                        <div className="inputStyle">
                          <Typography
                            className="headingStyle"
                            sx={{
                              marginTop: "40px",
                              marginRight: "32px",
                              fontFamily: "Verdana",
                              fontWeight: 600,
                            }}
                          >
                            Minimum Stock
                          </Typography>
                        </div>
                        <div className="inputStyle">
                          <Typography
                            className="headingStyle"
                            sx={{
                              fontFamily: "Verdana",
                              fontSize: "16px",
                              color: "black",
                              fontWeight: 600,
                              marginLeft: "50px",
                            }}
                          >
                            Current Value
                          </Typography>
                          <input
                            autoComplete="off"
                            name="abcIndicator"
                            // onChange={handleChange}
                            // type="number"
                            type="text" // Change type to text
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value={minStockCurrentValue}
                            onChange={(e) =>
                              handleInputChange(e, "minStockCurrentValue")
                            }
                            disabled
                            style={{
                              background: "rgb(239, 239, 239)",
                              width: "140px",
                            }}
                            className="partInputField partInputFieldEq"
                            // readOnly
                            // style={{
                            //   backgroundColor: "#f0f0f0",
                            //   cursor: "not-allowed",
                            // }}
                          />
                        </div>
                        <div className="inputStyle">
                          <Typography
                            className="headingStyle"
                            sx={{
                              fontFamily: "Verdana",
                              fontSize: "16px",
                              color: "black",
                              fontWeight: 600,
                              marginLeft: "50px",
                            }}
                          >
                            Proposed Value
                          </Typography>
                          <input
                            autoComplete="off"
                            name="criticalPart"
                            onChange={(e) =>
                              handleInputChange(e, "minFutCurrentValue")
                            }
                            // type="number"
                            type="text" // Change type to text
                            pattern="[0-9]*"
                            inputmode="numeric"
                            style={{
                              width: "140px",
                            }}
                            value={minFutCurrentValue}
                            className="partInputField partInputFieldEq"
                          />
                        </div>

                        {(minFutCurrValueChanged || maxFutCurrValueChanged) && (
                          <div className="inputStyle">
                            <Typography
                              className="headingStyle"
                              sx={{
                                fontFamily: "Verdana",
                                fontSize: "16px",
                                color: "black",
                                fontWeight: 600,
                                marginLeft: "50px",
                              }}
                            >
                              Reason for Change
                            </Typography>
                            {minFutCurrValueChanged && (
                              <input
                                autoComplete="off"
                                style={{
                                  width: "140px",
                                  marginLeft: "10px",
                                }}
                                name="bin"
                                onChange={(e) =>
                                  handleInputChange(e, "minJustValue")
                                }
                                type="text"
                                value={minJustValue}
                                // disabled={!minFutCurrValueChanged}
                                className="partInputMinStock"
                              />
                            )}
                          </div>
                        )}
                      </div>
                      {/* <Divider style={{ marginTop: "20px" }} /> */}
                      <div style={{ display: "flex", flexWrap: "wrap" }}>
                        <div className="inputStyle">
                          <Typography
                            className="headingStyle"
                            sx={{
                              marginTop: "40px",
                              marginRight: "30px",
                              fontFamily: "Verdana",
                              fontWeight: 600,
                            }}
                          >
                            Maximum Stock
                          </Typography>
                        </div>
                        <div className="inputStyle">
                          <input
                            autoComplete="off"
                            placeholder=""
                            name="abcIndicator"
                            disabled
                            style={{
                              background: "rgb(239, 239, 239)",
                              marginTop: "35px",
                              width: "140px",
                              marginLeft: "50px",
                            }}
                            // onChange={handleChange}
                            // type="number"
                            type="text" // Change type to text
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value={maxStockCurrentValue}
                            className="partInputField partInputFieldEq"
                            // style={{ marginTop: "35px", readOnly
                            onChange={(e) =>
                              handleInputChange(e, "maxStockCurrentValue")
                            }
                            // readOnly
                          />
                        </div>
                        <div className="inputStyle">
                          <input
                            autoComplete="off"
                            style={{
                              marginTop: "35px",
                              width: "143px",
                              marginLeft: "25px",
                            }}
                            placeholder=""
                            name="criticalPart"
                            onChange={(e) =>
                              handleInputChange(e, "maxFutCurrentValue")
                            }
                            // type="number"
                            type="text" // Change type to text
                            pattern="[0-9]*"
                            inputmode="numeric"
                            value={maxFutCurrentValue}
                            className="partInputField partInputFieldEq"
                          />
                        </div>
                        {maxFutCurrValueChanged && (
                          <div className="inputStyle">
                            <Typography
                              className="headingStyle"
                              sx={{
                                fontFamily: "Verdana",
                                fontSize: "13px",
                                visibility: "hidden",
                              }}
                            >
                              Reason for Change
                            </Typography>
                            <input
                              autoComplete="off"
                              placeholder=""
                              name="bin"
                              onChange={(e) =>
                                handleInputChange(e, "maxJustValue")
                              }
                              type="text"
                              className="partInputField"
                              value={maxJustValue}
                              disabled={!maxFutCurrValueChanged}
                              style={{
                                marginTop: "15px",
                                width: "140px",
                                marginLeft: "35px",
                              }}
                            />
                          </div>
                        )}
                      </div>
                    </CardContent>
                  </Card>
                  <Card sx={{ mt: 2 }}>
                    {" "}
                    <CardContent sx={{ mt: 2, margin: "20px" }}>
                      <div className="modificationStyle">
                        <Typography
                          sx={{
                            fontFamily: "Verdana",
                            fontSize: "18px",
                            fontWeight: 700,
                            color: "#C6003D",
                            marginTop: "10px",
                          }}
                        >
                          Flag for Deletion
                        </Typography>
                      </div>
                      {/* <Divider
                      style={{ margin: "20px 0px", background: "#EFEFEF" }}
                    /> */}
                      <div className="valueDisplay" style={{ margin: "20px" }}>
                        <Typography className="subHeading">Df Plant</Typography>
                        <ValueDisplay
                          future={false}
                          current={false}
                          // currentValue={
                          //   dialogData?.df_plant
                          //     ? dialogData?.df_plant === "X"
                          //       ? "Deactivate"
                          //       : "Active"
                          //     : "Active"
                          // }
                        />
                        {/* <Switch
                    checked={dfFlag == "X" ? true :false}
                    onChange={handleToggleChangePlant}
                    sx={{
                      borderRadius: "50px",
                      //   marginLeft: "25px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "50px",
                      "& .Mui-checked": {
                        color: "#C6003D", // Change the color to red when the switch is checked
                      },
                    }}
                    inputProps={{ "aria-label": "toggle" }}
                    color="default"
                  /> */}
                        <Switch
                          checked={dfFlag === "X"}
                          onChange={handleToggleChangePlant}
                          sx={{
                            borderRadius: "50px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#C6003D",
                              "& + .MuiSwitch-track": {
                                backgroundColor: "#C6003D",
                              },
                            },
                            "& .MuiSwitch-switchBase:hover": {
                              backgroundColor: "rgba(198, 0, 61, 0.08)",
                            },
                            "& .MuiSwitch-track": {
                              borderRadius: "50px",
                              backgroundColor: "#E9E9EA",
                              opacity: 1,
                            },
                          }}
                          inputProps={{ "aria-label": "toggle" }}
                          color="default"
                        />
                      </div>

                      <div></div>
                      {/* <Divider
                      style={{ background: "#EFEFEF", margin: "4px 0px" }}
                    /> */}
                      <div className="valueDisplay" style={{ margin: "20px" }}>
                        <Typography className="subHeading">
                          Df Storage Location
                        </Typography>
                        <ValueDisplay
                          future={false}
                          current={false}
                          // currentValue={
                          //   dialogData?.df_storage_location
                          //     ? dialogData?.df_storage_location === "X"
                          //       ? "Deactivate"
                          //       : "Active"
                          //     : "Active"
                          // }
                        />
                        {/* <Switch
                    checked={dfStorage === "X" ? true : false}
                    onChange={handleToggleChangeStorage}
                    sx={{
                      borderRadius: "50px",
                      //   marginLeft: "25px",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                      borderRadius: "50px",
                      "& .Mui-checked": {
                        color: "#C6003D", // Change the color to red when the switch is checked
                      },
                    }}
                    inputProps={{ "aria-label": "toggle" }}
                    color="default"
                  /> */}
                        <Switch
                          checked={dfStorage === "X"}
                          onChange={handleToggleChangeStorage}
                          sx={{
                            borderRadius: "50px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            "& .MuiSwitch-switchBase.Mui-checked": {
                              color: "#C6003D",
                              "& + .MuiSwitch-track": {
                                backgroundColor: "#C6003D",
                              },
                            },
                            "& .MuiSwitch-switchBase:hover": {
                              backgroundColor: "rgba(198, 0, 61, 0.08)",
                            },
                            "& .MuiSwitch-track": {
                              borderRadius: "50px",
                              backgroundColor: "#E9E9EA",
                              opacity: 1,
                            },
                          }}
                          inputProps={{ "aria-label": "toggle" }}
                          color="default"
                        />
                        <div></div>
                      </div>
                    </CardContent>
                  </Card>
                  <Card sx={{ mt: 2 }}>
                    {" "}
                    <CardContent sx={{ mt: 2, margin: "20px" }}>
                      <>
                        <div className="modificationStyle">
                          <Typography
                            sx={{
                              fontFamily: "Verdana",
                              fontSize: "18px",
                              fontWeight: 700,
                              color: "#C6003D",
                            }}
                          >
                            Plant Changes
                          </Typography>
                        </div>
                        {/* <Divider
                        style={{ margin: "20px 0px", background: "#EFEFEF" }}
                      /> */}
                        <div>
                          <div style={{ margin: "40px" }}>
                            {/* <div className="modificationStyle">
                    <Typography
                      sx={{
                        fontFamily: "Verdana",
                        fontSize: "18px",
                        fontWeight: 700,
                        color: "#C6003D",
                      }}
                    >
                      Plant Changes
                    </Typography>
                  </div>
                  <Divider sx={{ marginTop: "10px", marginBottom: "15px" }} /> */}
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              <div className="column" style={{ flex: "0.5" }}>
                                <Typography
                                  className="headingStyle"
                                  sx={{
                                    marginTop: "32px",
                                    marginRight: "30px",
                                    fontFamily: "Verdana",
                                    fontWeight: 600,
                                  }}
                                >
                                  ABC Indicator
                                </Typography>
                              </div>
                              <div className="column" style={{ flex: "0.5" }}>
                                <Typography
                                  className="headingStyle"
                                  sx={{
                                    fontFamily: "Verdana",
                                    fontSize: "13px",
                                    marginLeft: "13px",
                                    fontWeight: 600,
                                  }}
                                >
                                  Current Value
                                </Typography>

                                <input
                                  autoComplete="off"
                                  name="abcIndicator"
                                  className="partInputField"
                                  disabled
                                  value={dialogData?.future_abc_indicator}
                                  style={{
                                    background: "rgb(239, 239, 239)",
                                    width: "140px",
                                  }}

                                  // style={{
                                  //   backgroundColor: "#f0f0f0",
                                  //   cursor: "not-allowed",
                                  // }}
                                  // readOnly
                                />
                              </div>
                              <div className="column" style={{ flex: "0.5" }}>
                                <Typography
                                  className="headingStyle"
                                  sx={{
                                    fontFamily: "Verdana",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    position: "relative",
                                    left: "12px",
                                  }}
                                >
                                  Proposed Value
                                </Typography>
                                {/* <input
autoComplete="off" 
                        name="futAbcIndicator"
                        onChange={(e) =>
                          handlePlantInputChange(e, "futAbcIndicator")
                        }
                        style={{
                          width: "140px"
                        }} 
                        type="text"
                        value={futAbcIndicator}
                        className="partInputField"
                      /> */}
                                <FormControl
                                  sx={{
                                    width: "136px",
                                    margin: "10px 20px 8px 10px",
                                  }}
                                >
                                  <Select
                                    value={futAbcIndicator}
                                    onChange={handleSelectABCChange}
                                    IconComponent={() => (
                                      <DropdownIcon
                                        style={{
                                          width: "20px",
                                          position: "relative",
                                          left: "-10px",
                                        }}
                                      />
                                    )}
                                    sx={{ height: "32px" }}
                                  >
                                    {ABCoptions.map((option) => (
                                      <MenuItem key={option} value={option}>
                                        {option}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </div>
                              {/* {!abcFutCurrValueChanged && (
                      <div className="column" style={{ flex: "1.5" }}></div>
                    )} */}
                              {/* {abcFutCurrValueChanged && ( */}
                              <div
                                className="column"
                                style={{
                                  flex: "0.5",
                                  visibility: abcFutCurrValueChanged
                                    ? "visible"
                                    : "hidden",
                                }}
                              >
                                <Typography
                                  className="headingStyle"
                                  sx={{
                                    fontFamily: "Verdana",
                                    fontSize: "13px",
                                    fontWeight: 600,
                                    position: "relative",
                                    left: "20px",
                                  }}
                                >
                                  Reason for Change
                                </Typography>
                                <input
                                  autoComplete="off"
                                  style={{
                                    width: "140px",
                                  }}
                                  name="justiAbcIndicator"
                                  onChange={(e) =>
                                    handlePlantInputChange(
                                      e,
                                      "justiAbcIndicator",
                                    )
                                  }
                                  type="text"
                                  value={justiAbcIndicator}
                                  className="partInputField"
                                  //   disabled={!minFutCurrValueChanged}
                                />
                              </div>
                              {/* )} */}
                            </div>
                            <Divider />
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              <div className="column" style={{ flex: "0.5" }}>
                                <Typography
                                  className="headingStyle"
                                  sx={{
                                    marginTop: "33px",
                                    marginRight: "30px",
                                    fontFamily: "Verdana",
                                    fontWeight: 600,
                                  }}
                                >
                                  Criticality Indicator
                                </Typography>
                              </div>
                              <div
                                className="column"
                                style={{ flex: "0.5", marginTop: "20px" }}
                              >
                                <input
                                  autoComplete="off"
                                  name="critcialIndicator"
                                  disabled
                                  style={{
                                    background: "rgb(239, 239, 239)",
                                    width: "140px",
                                  }}
                                  // onChange={(e) =>
                                  //   handlePlantInputChange(e, "critcialIndicator")
                                  // }
                                  type="text"
                                  value={dialogData?.critical_part}
                                  className="partInputField"
                                />
                              </div>
                              <div
                                className="column"
                                style={{ flex: "0.5", marginTop: "20px" }}
                              >
                                {/* <FormControl sx={{
                        borderRadius: "8px",
                        margin: "10px 20px 10px 10px !important",
                        width: "140px",
                        outlineStyle: "none",
                        border: "1px solid #cbc3c3",
                        textAlign: "center"
                      }}>
                        <Select
                          value={futurecritcialIndicator}
                          onChange={handleIndicatorSelectChange}
                          renderValue={(selected) => (
                            <div>
                              <span key={selected}>{selected}</span>
                            </div>
                          )}
                          sx={{
                            padding: "0px !important",
                            height: "32px"
                          }}
                        >
                          <MenuItem value="">
                            <Checkbox checked={futurecritcialIndicator === ""} />
                            <ListItemText primary="Blank" />
                          </MenuItem>
                          <MenuItem value="X">
                            <Checkbox checked={futurecritcialIndicator === "X"} />
                            <ListItemText primary="X" />
                          </MenuItem>
                        </Select>
                      </FormControl> */}
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          futurecritcialIndicator === "X"
                                        }
                                        style={{
                                          color: "#575555",
                                          position: "relative",
                                          left: "70px",
                                        }}
                                        onChange={handleIndicatorSelectChange}
                                      />
                                    }
                                    // label="My Checkbox"
                                  />
                                </FormGroup>
                                {/* <input
                        autoComplete="off"
                        style={{
                          width: "1400px",
                        }}
                        placeholder=""
                        name="futurecritcialIndicator"
                        onChange={(e) =>
                          handlePlantInputChange(e, "futurecritcialIndicator")
                        }
                        className="partInputField"
                        value={futurecritcialIndicator}
                        onChange={(e) =>
                        setFutureValues({
                          ...futureValues,
                          criticalPart: e.target.value,
                        })
                      }
                      /> */}
                              </div>
                              <div
                                className="column"
                                style={{
                                  flex: "0.5",
                                  marginTop: "20px",
                                  visibility: "hidden",
                                }}
                              >
                                <input
                                  autoComplete="off"
                                  style={{
                                    width: "140px",
                                  }}
                                  placeholder=""
                                  name="criticalPart"
                                  className="partInputField"
                                  // value={justifications.abcIndicator}
                                  // onChange={(e) =>
                                  //   setJustifications({
                                  //     ...justifications,
                                  //     criticalPart: e.target.value,
                                  //   })
                                  // }
                                />
                              </div>
                            </div>

                            <Divider />
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              <div className="column" style={{ flex: "0.5" }}>
                                <Typography
                                  className="headingStyle"
                                  sx={{
                                    marginTop: "33px",
                                    marginRight: "30px",
                                    fontFamily: "Verdana",
                                    fontWeight: 600,
                                  }}
                                >
                                  Storage Location
                                </Typography>
                              </div>
                              <div
                                className="column"
                                style={{ flex: "0.5", marginTop: "20px" }}
                              >
                                <input
                                  autoComplete="off"
                                  disabled
                                  name="storageLocation"
                                  style={{
                                    background: "rgb(239, 239, 239)",
                                    width: "140px",
                                  }}
                                  // onChange={(e) =>
                                  //   handlePlantInputChange(e, "storageLocation")
                                  // }
                                  type="text"
                                  value={dialogData?.storage_location}
                                  className="partInputField"
                                />
                              </div>
                              <div
                                className="column"
                                style={{ flex: "0.5", marginTop: "20px" }}
                              >
                                <input
                                  autoComplete="off"
                                  placeholder=""
                                  name="futurestorageLocation"
                                  onChange={(e) =>
                                    handlePlantInputChange(
                                      e,
                                      "futurestorageLocation",
                                    )
                                  }
                                  style={{
                                    width: "140px",
                                  }}
                                  className="partInputField"
                                  value={futurestorageLocation}
                                  // onChange={(e) =>
                                  //   setFutureValues({
                                  //     ...futureValues,
                                  //     sloc: e.target.value,
                                  //   })
                                  // }
                                />
                              </div>
                              <div
                                className="column"
                                style={{
                                  flex: "0.5",
                                  marginTop: "20px",
                                  visibility: "hidden",
                                }}
                              >
                                <input
                                  autoComplete="off"
                                  style={{
                                    width: "140px",
                                  }}
                                  placeholder=""
                                  name="criticalPart"
                                  className="partInputField"
                                  // value={futureValues.abcIndicator}
                                  // onChange={(e) =>
                                  //   setJustifications({
                                  //     ...justifications,
                                  //     criticalPart: e.target.value,
                                  //   })
                                  // }
                                />
                              </div>
                            </div>

                            <Divider />
                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                              <div className="column" style={{ flex: "0.5" }}>
                                <Typography
                                  className="headingStyle"
                                  sx={{
                                    marginTop: "35px",
                                    marginRight: "30px",
                                    fontFamily: "Verdana",
                                    fontWeight: 600,
                                  }}
                                >
                                  Storage Bin
                                </Typography>
                              </div>

                              <div
                                className="column"
                                style={{ flex: "0.5", marginTop: "20px" }}
                              >
                                <input
                                  autoComplete="off"
                                  name="storageBin"
                                  disabled
                                  style={{
                                    background: "rgb(239, 239, 239)",
                                    width: "140px",
                                  }}
                                  // onChange={(e) =>
                                  //   handlePlantInputChange(e, "storageBin")
                                  // }
                                  type="text"
                                  value={dialogData?.storage_bin}
                                  className="partInputField"
                                />
                              </div>
                              <div
                                className="column"
                                style={{ flex: "0.5", marginTop: "20px" }}
                              >
                                <input
                                  autoComplete="off"
                                  placeholder=""
                                  name="futurestorageBin"
                                  onChange={(e) =>
                                    handlePlantInputChange(
                                      e,
                                      "futurestorageBin",
                                    )
                                  }
                                  style={{
                                    width: "140px",
                                  }}
                                  className="partInputField"
                                  value={futurestorageBin}
                                  // onChange={(e) =>
                                  //   setFutureValues({
                                  //     ...futureValues,
                                  //     bin: e.target.value,
                                  //   })
                                  // }
                                />
                              </div>
                              <div
                                className="column"
                                style={{
                                  flex: "0.5",
                                  marginTop: "20px",
                                  visibility: "hidden",
                                }}
                              >
                                <input
                                  autoComplete="off"
                                  placeholder="-"
                                  style={{
                                    width: "140px",
                                  }}
                                  name="criticalPart"
                                  className="partInputField"
                                  // value={justifications.bin}
                                  // onChange={(e) =>
                                  //   setJustifications({
                                  //     ...justifications,
                                  //     criticalPart: e.target.value,
                                  //   })
                                  // }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <div className="creationHeadingMod">
                          <Typography style={{ color: "black", fontWeight: 600, marginLeft:"50px"}}>
                            Current Value
                          </Typography>
                          <Typography style={{ color: "black", fontWeight: 600,marginLeft:"50px" }}>
                            Proposed Value
                          </Typography>
                          <Typography style={{ color: "black", fontWeight: 600, marginLeft:"50px"}}>
                            Reason for Change
                          </Typography>
                        </div> */}
                        {/* <div className="valueDisplay">
                          <Typography className="subHeading">
                            ABC Indicator
                          </Typography>
                          <ValueDisplay
                            future={true}
                            current={true}
                            justification={true}
                            futureValue={
                              dialogData?.future_abc_indicator
                                ? dialogData?.future_abc_indicator
                                : "-"
                            }
                            currentValue={
                              dialogData?.ABC_indicator
                                ? dialogData?.ABC_indicator
                                : "-"
                            }
                            justifyValue={
                              dialogData?.justification_for_change_in_abc_indicator
                                ? dialogData?.justification_for_change_in_abc_indicator
                                : "-"
                            }
                          />
                        </div> */}
                      </>

                      {/* <div className="valueDisplay">
                        <Typography className="subHeading">
                          Criticality Indicator
                        </Typography>
                        <ValueDisplay
                          future={true}
                          justification={false}
                          futureValue={
                            dialogData?.critical_part
                              ? dialogData?.critical_part
                              : "-"
                          }
                        />
                      </div> */}
                      {/* <Divider
                    style={{ background: "#EFEFEF", margin: "4px 0px" }}
                  /> */}
                      {/* <div className="valueDisplay">
                        <Typography className="subHeading">
                          Storage Location
                        </Typography>
                        <ValueDisplay
                          future={true}
                          justification={false}
                          futureValue={
                            dialogData?.storage_location
                              ? dialogData?.storage_location
                              : "-"
                          }
                        />
                      </div> */}
                      {/* <Divider
                    style={{ background: "#EFEFEF", margin: "4px 0px" }}
                  /> */}
                      {/* <div className="valueDisplay">
                        <Typography className="subHeading">
                          Storage Bin
                        </Typography>
                        <ValueDisplay
                          future={true}
                          justification={false}
                          futureValue={
                            dialogData?.storage_bin
                              ? dialogData?.storage_bin
                              : "-"
                          }
                        />
                      </div> */}
                    </CardContent>
                  </Card>
                </>
              )}

              {modificationType === "attribute" && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      margin: "10px",
                    }}
                  >
                    <Typography
                      style={headingStyle}
                      sx={{ color: "#212F37", fontSize: "18px" }}
                    >
                      Noun
                    </Typography>
                    <Typography
                      style={{
                        margin: "0px 20px",
                        background: "#EFEFEF",
                        padding: "4px",
                        borderRdius: "4px",
                      }}
                    >
                      {dialogData?.noun_indentifier}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      margin: "10px",
                    }}
                  >
                    <Typography
                      style={headingStyle}
                      sx={{ color: "#212F37", fontSize: "18px" }}
                    >
                      Modifier
                    </Typography>
                    <Typography
                      style={{
                        margin: "0px 20px",
                        background: "#EFEFEF",
                        padding: "4px",
                        borderRdius: "4px",
                      }}
                    >
                      {dialogData?.modifier}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px",
                    }}
                  >
                    <Typography
                      style={headingStyle}
                      sx={{ color: "#212F37", fontSize: "18px" }}
                    >
                      Short Description
                    </Typography>
                    <Typography style={{ margin: "10px 0px" }}>
                      {dialogData?.clean_short_description}
                    </Typography>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "10px",
                    }}
                  >
                    <Typography
                      style={headingStyle}
                      sx={{ color: "#212F37", fontSize: "18px" }}
                    >
                      Data Attributes
                    </Typography>
                    <Typography style={{ margin: "10px 0px" }}>
                      {MaterialCardData()}
                    </Typography>
                  </div>
                </div>
              )}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  color: "#212F37",
                }}
              >
                <Typography style={headingStyle} sx={{ marginTop: "30px" }}>
                  Comments
                  <span
                    style={{
                      color: "#C6003D",
                      margin: "4px",
                      fontSize: "18px",
                    }}
                  >
                    *
                  </span>
                </Typography>
                <TextareaAutosize
                  id="yourTextarea"
                  name="yourTextarea"
                  placeholder="Enter Comments"
                  value={ownerComment}
                  onChange={(e) => setOwnerComment(e?.target?.value)}
                  className="partTextField"
                  rows={10}
                  cols={50}
                  style={{
                    width: "50%",
                    fontFamily: "Verdana", // Set the font family to Verdana
                    minHeight: "50px",
                  }}
                />
              </div>
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions
          sx={{
            margin: "auto !important",
            // justifyContent: "flex-start !important",
          }}
        >
          <button
            type="submit"
            className="submitButton"
            style={{
              fontSize: 16,
              cursor: "pointer",
              position: "relative",
              fontFamily: "Verdana",
            }}
            onClick={(e) => {
              e.preventDefault();
              if (!ownerComment.trim()) {
                toast.error("Please enter a comment before approving.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 800,
                });
                return;
              }
              handleApproveRequest();
            }}
            disabled={!isEnabled || loading || loadingReject}
          >
            {loading ? (
              // Render loader or loading state here
              <div>Loading...</div>
            ) : (
              // Render button text
              "Approve"
            )}
          </button>
          <button
            type="submit"
            className="submitButton"
            style={{
              fontSize: 16,
              cursor: "pointer",
              position: "relative",
              fontFamily: "Verdana",
            }}
            onClick={(e) => {
              e.preventDefault();
              if (!ownerComment.trim()) {
                toast.error("Please enter a comment before rework.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 800,
                });
                return;
              }
              handleRejectRequest();
            }}
            disabled={!isEnabled || loading || loadingReject}
          >
            {loadingReject ? <div>Loading...</div> : "Rework"}
          </button>
          <button
            type="submit"
            className="submitButton"
            style={{
              fontSize: 16,
              cursor: "pointer",
              position: "relative",
              fontFamily: "Verdana",
            }}
            onClick={(e) => {
              e.preventDefault();
              if (!ownerComment.trim()) {
                toast.error("Please enter a comment before rejecting.", {
                  position: toast.POSITION.TOP_CENTER,
                  autoClose: 800,
                });
                return;
              }
              handleRejectRequest();
            }}
            disabled={!isEnabled || loading || loadingReject}
          >
            {loadingReject ? (
              // Render loader or loading state here
              <div>Loading...</div>
            ) : (
              // Render button text
              "Reject"
            )}
          </button>
          <button
            type="submit"
            className="cancelButton"
            style={{
              fontSize: 16,
              cursor: "pointer",
              position: "relative",
              fontFamily: "Verdana",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleClose();
            }}
          >
            Cancel
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OwnerModificationDialog;
